import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { EntregaEquipoLinkService } from 'src/app/pages/services/entrega-equipo-link.service';
import { EquipoTecnologicoService } from 'src/app/pages/services/equipo-tecnologico.service';
import { TipoMovimientoEntregaEquipo } from 'src/app/shared/models/entrega-equipo-link.interface';

@Component({
  selector: 'app-editar-movimiento-dialog',
  templateUrl: './editar-movimiento-dialog.component.html',
})
export class EditarMovimientoDialogComponent {

  tiposMovimiento: TipoMovimientoEntregaEquipo[] = ['ENTREGA', 'DEVOLUCION', 'REEMPLAZO'];

  form: {
    tipoMovimiento: TipoMovimientoEntregaEquipo;
    fechaMovimiento: string;
    observacion: string;
  };

  equipoActual: any;
  textoBusquedaEquipo: string = '';
  equiposEncontrados: any[] = [];
  guardando: boolean = false;

  // Edición directa de modelo/N° serie del equipo actual (sin tener que buscar/reemplazar
  // por otro registro del catálogo).
  equipoModeloEditado: string = '';
  equipoNumeroSerieEditado: string = '';
  equiposSimilaresEncontrados: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<EditarMovimientoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private alert: AlertHelper,
    private entregaEquipoLinkService: EntregaEquipoLinkService,
    private equipoTecnologicoService: EquipoTecnologicoService
  ) {
    const movimiento = data.movimiento;
    this.form = {
      tipoMovimiento: movimiento.tipoMovimiento,
      fechaMovimiento: movimiento.fechaMovimiento ? new Date(movimiento.fechaMovimiento).toISOString().slice(0, 16) : '',
      observacion: movimiento.observacion || ''
    };
    this.equipoActual = movimiento.EquipoTecnologico
      ? { id: movimiento.fk_equipoTecnologico, ...movimiento.EquipoTecnologico }
      : null;
    this.equipoModeloEditado = this.equipoActual?.modelo || '';
    this.equipoNumeroSerieEditado = this.equipoActual?.numeroSerie || '';
  }

  onNumeroSerieEditadoBlur() {
    const valor = this.equipoNumeroSerieEditado?.trim();
    if (!valor || valor.length < 2 || valor.toUpperCase() === (this.equipoActual?.numeroSerie || '').toUpperCase()) {
      this.equiposSimilaresEncontrados = [];
      return;
    }
    this.entregaEquipoLinkService.buscarEquiposSimilares(valor).subscribe(res => {
      this.equiposSimilaresEncontrados = (res.data || []).filter((eq: any) => eq.id !== this.equipoActual?.id);
    });
  }

  usarEquipoSimilar(equipo: any) {
    this.equipoNumeroSerieEditado = equipo.numeroSerie;
    this.equiposSimilaresEncontrados = [];
  }

  onBuscarEquipo(event: Event) {
    const texto = (event.target as HTMLInputElement).value;
    if (!texto || texto.trim().length === 0) {
      this.equiposEncontrados = [];
      return;
    }
    this.equipoTecnologicoService.buscarEquipos(texto.trim()).subscribe(res => {
      this.equiposEncontrados = res.data || [];
    });
  }

  seleccionarEquipo(equipo: any) {
    this.equipoActual = equipo;
    this.equiposEncontrados = [];
    this.textoBusquedaEquipo = '';
    this.equipoModeloEditado = equipo.modelo || '';
    this.equipoNumeroSerieEditado = equipo.numeroSerie || '';
    this.equiposSimilaresEncontrados = [];
  }

  guardar() {
    this.guardando = true;

    const equipoModeloCambio = this.equipoActual && this.equipoModeloEditado.trim() !== this.equipoActual.modelo;
    const equipoSerieCambio = this.equipoActual && this.equipoNumeroSerieEditado.trim() !== this.equipoActual.numeroSerie;

    if (this.equipoActual && (equipoModeloCambio || equipoSerieCambio)) {
      this.equipoTecnologicoService.actualizarEquipo({
        id: this.equipoActual.id,
        tipo: this.equipoActual.tipo,
        marca: this.equipoActual.marca,
        modelo: this.equipoModeloEditado.trim(),
        chip: this.equipoActual.chip,
        numeroSerie: this.equipoNumeroSerieEditado.trim(),
        estado: this.equipoActual.estado,
        accesorios: this.equipoActual.accesorios,
        observacion: this.equipoActual.observacion
      }).subscribe({
        next: (res) => {
          if (res.success) {
            this.guardarMovimiento();
          } else {
            this.guardando = false;
            this.alert.error_small(res.msg || 'No se pudo actualizar el equipo');
          }
        },
        error: () => { this.guardando = false; }
      });
    } else {
      this.guardarMovimiento();
    }
  }

  private guardarMovimiento() {
    const cambios: any = {
      tipoMovimiento: this.form.tipoMovimiento,
      fechaMovimiento: this.form.fechaMovimiento ? new Date(this.form.fechaMovimiento) : null,
      observacion: this.form.observacion,
      fk_equipoTecnologico: this.equipoActual ? this.equipoActual.id : null
    };
    this.entregaEquipoLinkService.editarMovimiento(this.data.movimiento.id, cambios).subscribe({
      next: (res) => {
        this.guardando = false;
        if (res.success) {
          this.alert.success_small(res.msg || 'Movimiento actualizado');
          this.dialogRef.close(cambios);
        } else {
          this.alert.error_small(res.msg || 'No se pudo actualizar');
        }
      },
      error: () => { this.guardando = false; }
    });
  }

  cancelar() {
    this.dialogRef.close(false);
  }

}
